import { cn } from '@/lib/utils'
import { Centered } from '@/shared/layout/Centered'
import { FC, HTMLProps } from 'react'

interface RoundInputProps extends HTMLProps<HTMLDivElement> {
	valueToShow: string
	onIncrease: () => void
	onDecrease: () => void
	onValueClick?: () => void
}

export const RoundInput: FC<RoundInputProps> = ({
	valueToShow,
	onDecrease,
	onIncrease,
	onValueClick,
	...rest
}) => {
	return (
		<div
			{...rest}
			className={cn(
				'w-full rounded-[22px] border border-[#F0F0F0] bg-white px-5 py-3 shadow-[0_1px_6px_rgba(0,0,0,0.03)]',
				rest.className
			)}>
			<Centered>
				<div className='text-[12px] font-semibold uppercase tracking-[0.08em] text-[#6C71FF]'>
					Раунды
				</div>
			</Centered>
			<div className='mt-1 flex items-center justify-between'>
				<button
					type='button'
					aria-label='Уменьшить раунды'
					onClick={onDecrease}
					className='flex h-[46px] w-[46px] items-center justify-center rounded-full bg-[#F3F3F3] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black'>
					<div className='relative h-[18px] w-[18px]'>
						<span className='absolute inset-0 m-auto h-[2px] w-[18px] rounded-full bg-black' />
					</div>
				</button>
				<button
					type='button'
					onClick={onValueClick}
					disabled={!onValueClick}
					aria-label='Выбрать количество раундов'
					className='min-w-[112px] rounded-[18px] px-3 py-1 text-[46px] font-medium leading-none tracking-[-0.03em] transition active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black disabled:pointer-events-none disabled:bg-transparent'>
					{valueToShow}
				</button>
				<button
					type='button'
					aria-label='Увеличить раунды'
					onClick={onIncrease}
					className='flex h-[46px] w-[46px] items-center justify-center rounded-full bg-[#F3F3F3] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black'>
					<div className='relative h-[18px] w-[18px]'>
						<span className='absolute inset-0 m-auto h-[2px] w-[18px] rounded-full bg-black' />
						<span className='absolute inset-0 m-auto h-[18px] w-[2px] rounded-full bg-black' />
					</div>
				</button>
			</div>
		</div>
	)
}
